import * as yup from "yup";
import { t } from "i18next";
import eshopFormValidationService from "../general/EshopFormValidationService";
import fingerprintService from "../services/FingerprintService";
import { Validation } from "../localization/localeValidation";
import { assert } from "../../../js/common/assert";
import elementService from "@/common/ElementService";

interface RegisterFormValues {
    email: string;
    password: string;
    password2: string;
}

const registerSchema: yup.ObjectSchema<RegisterFormValues> = yup
    .object({
        email: yup
            .string()
            .trim()
            .lowercase()
            .required("E-mail je povinný.")
            .matches(Validation.EmailRegEx, t("header:validEmail")),
        password: yup
            .string()
            .required("Heslo je povinné.")
            .min(6, "Heslo musí mít alespoň 6 znaků."),
        password2: yup
            .string()
            .required("Prosím, zopakujte heslo.")
            .oneOf([yup.ref("password")], "Hesla se neshodují."),
    })
    .required()
    .noUnknown(true, "Neznámé pole.");

type RegisterFormSchema = yup.InferType<typeof registerSchema>;

export default class RegistrationPageService {
    public init(): void {
        this.initFormValidation();
        this.initShowPassword();
    }

    private initFormValidation(): void {
        const registerForm = elementService.querySelector<HTMLFormElement>("#js-register-form");

        eshopFormValidationService.init<RegisterFormSchema>(registerForm, registerSchema, {
            onValidSubmit: (values, form): void => {
                void this.submitForm(form);
            },
        });
    }

    private async submitForm(form: HTMLFormElement): Promise<void> {
        const fingerprint = await fingerprintService.getFingerprint();

        const inputValues = [
            { name: "fingerprint", value: fingerprint ?? "" },
            { name: "opex1", value: "142" },
            { name: "opex2", value: "" },
        ];

        for (const inputValue of inputValues) {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = inputValue.name;
            input.value = inputValue.value;
            form.appendChild(input);
        }

        form.submit();
    }

    private initShowPassword(): void {
        const toggleButtons = document.querySelectorAll<HTMLSpanElement>(".toggle-password");

        for (const button of toggleButtons) {
            button.addEventListener("click", (): void => {
                assert(button.parentElement !== null);
                const passwordInput = elementService.elementQuerySelector<HTMLInputElement>(button.parentElement, "input");

                const icon = elementService.elementQuerySelector<HTMLElement>(button, "i");

                if (passwordInput.type === "password") {
                    passwordInput.type = "text";
                    button.setAttribute("aria-pressed", "true");
                    icon.classList.remove("fa-eye");
                    icon.classList.add("fa-eye-slash");
                } else {
                    passwordInput.type = "password";
                    button.setAttribute("aria-pressed", "false");
                    icon.classList.remove("fa-eye-slash");
                    icon.classList.add("fa-eye");
                }
            });
        }
    }
}
